import { api, unwrap } from '../../shared/api/client';
import type { components } from '../../shared/api/schema.gen';

export type TPersonalNotifications = components['schemas']['PersonalNotificationSettingsResDto'];
export type TNotificationCategory = components['schemas']['NotificationCategoryBreakdownResDto'];
export type TNotificationChannelCell = components['schemas']['NotificationChannelBreakdownResDto'];
export type TNotificationChannel = TNotificationChannelCell['channel'];

export type TPersonalPatch = Record<string, Partial<Record<'in_app' | 'email', boolean>>>;

export const myNotifications = (): Promise<TPersonalNotifications> =>
  unwrap(api.GET('/v1/notifications/settings/me'));

export const saveMyNotifications = (matrix: TPersonalPatch): Promise<TPersonalNotifications> =>
  unwrap(api.PUT('/v1/notifications/settings/me', { body: { matrix } }));

export const sendPasswordResetEmail = async (email: string): Promise<void> => {
  await unwrap(api.POST('/v1/auth/forgot-password', { body: { email } }));
};

export const renameMe = (name: string): Promise<components['schemas']['UpdateProfileResDto']> =>
  unwrap(api.PATCH('/v1/users/me', { body: { name } }));
